export default __webpack_public_path__ + "static/EE-Beano-final-comic-book-d08ef64de91244e86b8a0933b3aa2a70.pdf";